// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1fYxA","container":"styles_container__2SzLG","title":"styles_title__2pfUF","wrapper":"styles_wrapper__12ccj","answer":"styles_answer__3l7uN"};